// extracted by mini-css-extract-plugin
export default {"addRoomPage":"AddRoomPage_addRoomPage__ibJPS","imageContainer":"AddRoomPage_imageContainer__0jjXm","error":"AddRoomPage_error__e+F+7"};